import { render } from "./Alerts.vue?vue&type=template&id=7fa23700&scoped=true"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"

import "./Alerts.vue?vue&type=style&index=0&id=7fa23700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa23700"]])

export default __exports__